<div class="card-container">
  <img [src]="item.icon" [style]="item.iconStyle" class="tunneler-icon" />
  <div class="tunneler-details">
    <h5 class="card-title">{{ item.title }}</h5>
    <p [innerHtml]="item.helpText" class="help-text"></p>
    @if (!item.useButton) {
      <a
        (click)="linkClicked()"
        [href]="item.link"
        [target]="item.target ? item.target : '_blank'"
        class="tunneler-link btn btn--sm btn--primary type--uppercase"
        >
        <span class="btn__text">{{ item.buttonText }}</span>
      </a>
    }
    @if (item.useButton) {
      <button (click)="linkClicked()" class="tunneler-button" id="ConfirmAction{{ item.os }}">
        {{ item.buttonText }}
      </button>
    }
  </div>
</div>
